export enum appUrl {
  appStore = 'https://apps.apple.com/ru/app/stock-pro-%D0%B0%D0%B2%D1%82%D0%BE-%D0%BD%D0%B0-%D0%B7%D0%B0%D0%BF%D1%87%D0%B0%D1%81%D1%82%D0%B8/id1572318186?referrer=appmetrica_tracking_id%3D675845937507081205%26ym_tracking_id%3D14452349345607165534',
  googlePlay = 'https://play.google.com/store/apps/details?id=com.stock_pro_rn&referrer=appmetrica_tracking_id%3D1108191506734299107%26ym_tracking_id%3D10271825066222448846',
}
